import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SectionHeader from '../Basic/SectionHeader';
import PasswordBox from '../Enhanced/PasswordBox';
import * as consts from '../../constants';

class DoublePassword extends React.Component {
  render() {
    const p = this.props;
    const s = p.value1 && p.value2 && (p.value1 != p.value2);
    const t1 = p.title1 ? p.title1 : "Enter your password";
    const t2 = p.title2 ? p.title2 : "Re-enter your password";
    return (
      <div>
        <SectionHeader title={p.title} />
        <PasswordBox name={p.name} title={t1} required={p.required} errorMsg="Password is required" pattern={consts.REGEX_PASSWORD} patternErrorMsg="Passwords must at least eight characters long and include at least one number, one lowercase letter and one capital letter." />
        <PasswordBox name={`${p.name}_2`} title={t2} isPassword required={p.required} errorMsg="Password is required" />
        {s ? <label className="control-label has-error validationMessage">Passwords do not match</label> : null}
      </div>
    );
  }
}
DoublePassword.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string,
};
const mapStateToProps = (state, props) => {
  return {
    value1: state.form && state.form[props.name],
    value2: state.form && state.form[props.name + '_2'],
  };
};
export default connect(mapStateToProps)(DoublePassword);
export function DoublePasswordValidation(name) {
  return [
    [name, p => p[name], "#Password is required"],
    [name + "_2", p => p[name+"_2"], "#Password is required"],
    [name + "_2", p => (p[name] == p[name + "_2"]), "#Passwords do not match"]
  ];
}